import React, { useCallback, useEffect, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { getSelectedPostTypeFilter } from 'src/shared/redux-state/src/lib/eyengage/EyengageSelector';
import { useAppDispatch, useAppSelector } from 'src/app/services/store';
import { updateSelectedPostTypeFilter } from 'src/shared/redux-state/src/lib/eyengage/EyengageHandler';
import { updateEyengageFilterApplied } from 'src/shared/redux-state/src/lib/eyengage/EyengageHandler';
import { fetchEyengagePosts } from 'src/shared/redux-state/src/lib/eyengage/EyengageHandler';
import { getCurrentChild } from 'src/shared/redux-state/src/lib/login/LoginSelectors';
import { ChildrenStoreData } from 'src/shared/types/src';
import { EngageFilterBody, EngageFilterFooter } from 'src/app/pages/eyengage/components/eyengageFilters';
import { isEqual, sortBy } from 'lodash';

type EyengageFilterModalProps = {
    isOpen: boolean,
    toggleModal: () => void,
}

const EyengageFilterModal: React.FC<EyengageFilterModalProps> = ({ isOpen, toggleModal }) => {
    const selectedTypeFilter = useAppSelector(getSelectedPostTypeFilter);
    const dispatch = useAppDispatch();
    const currentChild: ChildrenStoreData = useAppSelector(getCurrentChild);
    const [postFilterType, setPostFilterType] = useState(
        selectedTypeFilter || [],
    );
    const [orgPostFilterType, setOrgPostFilterType] = useState<Array<string> | null>(null);

    useEffect(() => {
        if (!orgPostFilterType && isOpen) {
            const params = new URLSearchParams(window.location.search);
            const filter = params.get('filter');
            if (filter) {
                const filtersArray = filter.split(',');
                setOrgPostFilterType(filtersArray);
            }
        }
        return () => {
            if (!isOpen) {
                setOrgPostFilterType(null);
            }
        }
    }, [isOpen, orgPostFilterType]);

    const applyEngageFilters = useCallback(async () => {
        if (!isEqual(sortBy(postFilterType), sortBy(selectedTypeFilter))){
            const postType = postFilterType.join(',');
            dispatch(fetchEyengagePosts({ child: currentChild, page: 1, type: postType }));
            dispatch(updateSelectedPostTypeFilter({ postFilter: postFilterType }));
            dispatch(updateEyengageFilterApplied({ filterApplied: postFilterType.length > 0 }));

            // Update query parameters
            const params = new URLSearchParams(window.location.search);
            params.set('filter', postType); // Assuming you want to set a 'filter' query param
            window.history.replaceState({}, '', postType && postType.length > 0 ? `${window.location.pathname}?${params.toString()}` : `${window.location.pathname}`);

            window.scrollTo({ top: 0, behavior: 'smooth' }); // Smooth scroll to top
        }
        toggleModal();

    }, [currentChild, dispatch, postFilterType, selectedTypeFilter, toggleModal])

    const saveFilterTypeSelection = useCallback((data: any) => {
        if (isOpen) {
            setPostFilterType(data);
        }
    }, [isOpen]);

    return (
        <Modal 
            isOpen={isOpen} 
            toggle={toggleModal} 
            backdrop={true} 
            fade={false}
            className={`custom-modal-md modal-dialog-bottom modal-dialog-bottom-style`}
            modalClassName={`modal-slide-down`}
        >
            <ModalHeader>Apply Filter</ModalHeader>
            <ModalBody>
                <EngageFilterBody saveFilterTypeSelection={saveFilterTypeSelection}
                orgPostFilterType={orgPostFilterType} />
            </ModalBody>
            <ModalFooter>
                <EngageFilterFooter applyEngageFilters={applyEngageFilters} />
            </ModalFooter>
        </Modal>
    )
}

export default EyengageFilterModal;